import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import readAndCompressImage from 'browser-image-resizer';

class App extends Component {
  state = {
    image: null
  };

  getBase64 = file => {
    return new Promise(
      (resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = function (error) {
          reject('Error: ', error);
        };
      }
    );
  }
  onChange = event => {
    // ch-ch-change
    if (event.target.files[0]) {
      readAndCompressImage(event.target.files[0])
      .then(result => {
        return this.getBase64(result);
      })
      .then(image => {
        this.setState({image})
      });
    }
  };

  render() {
    return (
      <div className="App">
        <div className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h2>Welcome to React</h2>
        </div>
        <p className="App-intro">
          <input type="file" accept="image/*" onChange={this.onChange} />
          To get started, edit <code>src/App.js</code> and save to reload.
        </p>
        <p>
        <img src={this.state.image} alt="downscaled" />
        </p>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js